var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vld-parent"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "on-cancel": _vm.onCancel,
      "color": "var(--primary-color)",
      "opacity": 0.8,
      "is-full-page": _vm.fullPage
    },
    on: {
      "update:active": function updateActive($event) {
        _vm.isLoading = $event;
      }
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };